import AttachmentsList from '@app/components/AttachmentsList'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { ListingPageProps } from './ListingPage'

export default class PropertyFiles extends React.PureComponent<
  ListingPageProps
> {
  public render() {
    return (
      <DocumentTitle title={`${this.props.listing.title} :: Files`}>
        <div className='mb-3'>
          <h5 className='section-title'>Attachments</h5>
          <AttachmentsList
            attachments={this.props.listing.property.attachments}
            className='mx-3'
            onChange={this.props.setAttachments}
            propertyId={this.props.listing.property.id}
          />
        </div>
      </DocumentTitle>
    )
  }
}
